
import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { CountryItem } from '../types';
import CountryRow from './CountryRow';

interface DesktopCountryTableProps {
  countries: CountryItem[];
  editing: string | null;
  editData: CountryItem | null;
  onEditDataChange: (data: CountryItem) => void;
  onSave: () => void;
  onDelete: (id: string) => void;
  onToggleActive: (id: string) => void;
  onOpenDialog: (country: CountryItem) => void;
}

export const DesktopCountryTable: React.FC<DesktopCountryTableProps> = ({
  countries,
  editing,
  editData,
  onEditDataChange,
  onSave,
  onDelete,
  onToggleActive,
  onOpenDialog,
}) => {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Flag</TableHead>
            <TableHead>Country</TableHead>
            <TableHead>Code</TableHead>
            <TableHead>Region</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Hero Image</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {countries.map((country) => (
            <CountryRow
              key={country.code}
              country={country}
              editing={editing === country.id}
              editData={editData}
              onEditDataChange={onEditDataChange}
              onSave={onSave}
              onDelete={onDelete}
              onOpenDialog={onOpenDialog}
              onToggleActive={onToggleActive}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
